import { Injectable } from "@angular/core";
import { TreasuryPaymentBatchesService } from "lib-klab-sdks";
import { map, Observable, of } from "rxjs";
import { PaymentBatchesPort } from "../../../app/ports/treasury/payment-batches.port";
import { RequirementBatch } from "../../../domain/models/treasury/payment-batch.model";
import { mapTreasuryRequirementBatch } from "../../mappers/treasury/payment-batch.mapper";

@Injectable({ providedIn: "root" })
export class PaymentBatchesPortAdapter implements PaymentBatchesPort {
  constructor(private readonly api: TreasuryPaymentBatchesService) {}

  listRequirementBatches(requirementIds: readonly number[]): Observable<readonly RequirementBatch[]> {
    if (requirementIds.length === 0) {
      return of([]);
    }
    return this.api
      .listRequirementBatches(requirementIds)
      .pipe(map(({ data }) => data.map(mapTreasuryRequirementBatch)));
  }
}
